import type { LearningStoreGetters } from "@/store/learning/getters";
import type { LearningStoreState } from "@/store/learning/state";
import { useLearningAssessmentStore } from "@/store/learning/assessment/learningAssessmentStore";

export const modeGetters = {
    isLearning(_state: LearningStoreState & LearningStoreGetters): boolean {
        const assessmentStore = useLearningAssessmentStore();
        return !assessmentStore.isAssessment
            && !assessmentStore.isContest
            && !assessmentStore.isLevelAssessment
            && !assessmentStore.isProSkillAssure;
    },
    isAssessment(_state: LearningStoreState & LearningStoreGetters): boolean {
        return useLearningAssessmentStore().isAssessment;
    },
    isContest(_state: LearningStoreState & LearningStoreGetters): boolean {
        return useLearningAssessmentStore().isContest;
    },
    isLevelAssessment(_state: LearningStoreState & LearningStoreGetters): boolean {
        return useLearningAssessmentStore().isLevelAssessment;
    },
    isProSkillAssure(_state: LearningStoreState & LearningStoreGetters): boolean {
        return useLearningAssessmentStore().isProSkillAssure;
    },
    getDomainId(state: LearningStoreState & LearningStoreGetters): number | string {
        const assessmentStore = useLearningAssessmentStore();
        if (assessmentStore.isProSkillAssure) return assessmentStore.proSkillAssure.assessmentId;
        else if (assessmentStore.isContest) return assessmentStore.contestId;
        else if (state.isLearning) return state.course.id;
        else if (assessmentStore.isLevelAssessment) return assessmentStore.trackInfo.levelId;
        return 0;
    }
};
